import React from 'react';
import { AppContext } from "../App";
import { classIf } from '../data/utils/classIf';
import { isOverlaySection } from '../utils/sport-effects';
import { LiveContext } from './Live';
import LiveSporstNav from './live-suite/LiveSportsNav';

function IFrameContainer(props) {
    const appContext = React.useContext(AppContext);
    const liveContext = React.useContext(LiveContext);
    const hideWrapper = isOverlaySection(appContext,props.section);

    function handleClickSportsNav(sportId){
        liveContext.openLiveSuite(sportId)
    }

    return (
        <div id="main-wrapper" className={"wrapper" + classIf(hideWrapper, 'no-scroll d-none')}>
            <div id="main-container" className="main-content">
                <LiveSporstNav sports={liveContext.sports}  changeSport={handleClickSportsNav} />
                <iframe title="xs-live-iframe-container" src={props.src} />
            </div>
        </div>
    );
}

export default IFrameContainer;